import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import { getEventNames, getMyPermissions, getTenantId } from '../reducers/analyticsApp';
import { hasPermissions } from '../utils/permissions';
import { checkEvents } from '../utils/event/common';

const CheckedRoute = ({ children, tenantId, checkAccess, permissions, events }) => {
  const location = useLocation();

  return checkAccess(permissions, events) ? (
    children
  ) : (
    <Navigate
      to={{
        pathname: `/${tenantId}`,
        state: location,
      }}
    />
  );
};

const mapStateToProps = (state, props) => ({
  ...props,
  checkAccess: (permissions, events) =>
    checkEvents(events, getEventNames(state)) &&
    hasPermissions(permissions, getMyPermissions(state)),
  tenantId: getTenantId(state),
});

export default connect(mapStateToProps)(CheckedRoute);
